/**
 * PastLivesGlyph — wheel-of-souls icon for the Past Lives SKU.
 *
 * Concentric gold rings (outer solid, inner dashed) with a central spark
 * and four cardinal orbital dots, evoking the cycle of soul through time.
 * Fully decorative — caller must wrap with aria-hidden context if needed.
 */
export interface PastLivesGlyphProps {
  size?: number;
}

export function PastLivesGlyph({ size = 36 }: PastLivesGlyphProps): JSX.Element {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      focusable="false"
    >
      <defs>
        <radialGradient id="pl-core" cx="50%" cy="50%" r="50%">
          <stop offset="0%" stopColor="#fff3c4" />
          <stop offset="60%" stopColor="#f0c850" />
          <stop offset="100%" stopColor="#d6b86b" stopOpacity="0.0" />
        </radialGradient>
        <linearGradient id="pl-ring" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="#f3d97a" />
          <stop offset="100%" stopColor="#d6b86b" />
        </linearGradient>
      </defs>

      <circle cx="24" cy="24" r="21" stroke="url(#pl-ring)" strokeWidth="1.2" opacity="0.55" />
      <circle
        cx="24"
        cy="24"
        r="15"
        stroke="#d6b86b"
        strokeWidth="0.9"
        opacity="0.75"
        strokeDasharray="2 3"
      />
      <circle cx="24" cy="24" r="9" stroke="#f3d97a" strokeWidth="0.7" opacity="0.55" />

      <circle cx="24" cy="24" r="6" fill="url(#pl-core)" />
      <circle cx="24" cy="24" r="1.8" fill="#fff3c4" />

      <circle cx="24" cy="3" r="1.6" fill="#f3d97a" />
      <circle cx="45" cy="24" r="1.4" fill="#d6b86b" opacity="0.85" />
      <circle cx="24" cy="45" r="1.4" fill="#d6b86b" opacity="0.7" />
      <circle cx="3" cy="24" r="1.4" fill="#d6b86b" opacity="0.85" />
    </svg>
  );
}
